module.exports = __webpack_public_path__ + "img/new_1.ceadea75.png";